import React, { useState, useEffect } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import PageHeader from "components/headers/PageHeader";
import FooterCard from "components/footers/PageFooter";
import { SectionHeading } from "components/misc/Headings";
import { PrimaryButton } from "components/misc/Buttons";
import { useNavigate } from "react-router-dom";
import { AiFillLike, AiFillEye } from 'react-icons/ai';
import { FaComment } from 'react-icons/fa';

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV



const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`hover:text-[#0049AC]  lg:text-2xl mt-0 sm:text-sm md:text-sm`;

const SearchContainer = tw.div`flex items-center space-x-2 mt-4 sm:flex-row sm:justify-end w-full`;
const SearchInput = styled.input`
  ${tw`w-full max-w-lg px-4 py-2 border border-gray-300 rounded-lg focus:outline-none 
         focus:ring-2 focus:ring-[#0049AC] focus:border-transparent shadow-sm`};
`;
const SearchButton = tw.button`px-4 py-2 bg-[#0049AC] text-white rounded-lg transition duration-300`;

const Blogs = tw.div`top-0 sm:-mr-8 flex flex-wrap`;
const BlogContainer = styled.div`
  ${tw`mt-8 w-full sm:w-1/2 lg:w-1/3 sm:pr-8`}
  ${props =>
    props.featured &&
    css`
      ${tw`w-full!`}
      ${Blog} {
        ${tw`sm:-mr-8 sm:flex-row! h-full sm:pr-4`}
      }
      ${Image} {
        ${tw`bg-cover sm:w-1/2 lg:w-2/3 sm:rounded-t-none sm:rounded-l-lg sm:h-auto`}
      }
      ${Info} {
        ${tw`sm:-mr-4 sm:pl-4 sm:flex-1 sm:rounded-none sm:rounded-r-lg sm:border-t-2 sm:border-l-0 sm:h-auto`}
      }
      ${Description} {
        ${tw`text-sm mt-4 leading-loose text-gray-600 font-medium`}
      }
      ${CreationDate} {
        ${tw`mt-4`}
      }
      ${Title} {
        ${tw`mt-4`}
      }
      ${AuthorInfo} {
        ${tw`mt-6`}
      }
      ${Stats} {
        ${tw`mt-6`}
      } 
    `};
`;

const Blog = tw.div`cursor-pointer flex flex-col bg-gray-100 rounded-lg h-full`; // Added h-full for equal height
const Image = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-48 w-full bg-cover bg-center rounded-t-lg`};
`;


const Info = tw.div`p-4 border-2 border-t-0 rounded-lg rounded-t-none flex flex-col justify-between h-full`;
const Category = tw.div`uppercase text-[#0049AC] text-xs font-bold tracking-widest leading-loose after:content after:block after:border-b-2 after:border-[#0049AC] after:w-8`;
const CreationDate = tw.div`uppercase text-gray-600 italic font-semibold text-xs`;
const Title = tw.div`font-black text-xl text-gray-900 group-hover:text-[#0049AC] transition duration-300`;
const Description = tw.div`text-sm leading-loose text-gray-600 font-medium`;
const AuthorInfo = tw.div`flex items-center mt-2`;
const AuthorName = tw.div`text-sm font-medium text-gray-700`;

const Stats = tw.div`flex justify-between mt-2 text-xs text-gray-600`;
const StatItem = tw.div`flex items-center space-x-1`;

const ButtonContainer = tw.div`flex justify-end mr-0`;
const LoadMoreButton = tw(PrimaryButton)`mt-4 mx-auto`;
const WriteBlogButton = tw(PrimaryButton)`mt-1 mx-auto`;

const AuthorImage = tw.img`w-12 h-12 rounded-full`;
const AuthorNameAndProfession = tw.div`ml-2`;
const AuthorProfile = tw.p`text-secondary-100 text-sm`;

export default () => {
  const [blogs, setBlogs] = useState([]);
  const [visible, setVisible] = useState(7);
  const [featuredBlog, setFeaturedBlog] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const navigate = useNavigate();

  const dummyBlogs = [
    {
      "blog_id": 1,
      "blog_title": "The Great Himalayas",
      "blog_category": "Nature",
      "blog_description": "The Great Himalayas, with their towering peaks and breathtaking landscapes, offer some of the most awe-inspiring views in the world. Learn about the beauty and significance of this magnificent mountain range.",
      "blog_thumbnail": "https://images.pexels.com/photos/6153354/pexels-photo-6153354.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      "created_at": "2025-01-19T06:58:06.974Z",
      "updated_at": "2025-01-19T06:58:06.974Z",
      "author_name": "Vikas Kumar",
      "author_pic": "https://plus.unsplash.com/premium_photo-1689539137236-b68e436248de?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "author_designation": "Guide",
      "blog_views": "0",
      "blog_likes": "0",
      "blog_comments": "0"
    },
    {
      "blog_id": 2,
      "blog_title": "Exploring the Depths of the Ocean",
      "blog_category": "Science",
      "blog_description": "The ocean covers more than 70% of the Earth’s surface, yet much of it remains unexplored. Dive into the fascinating world of marine biology and discover the secrets of the deep sea.",
      "blog_thumbnail": "https://images.pexels.com/photos/1146301/pexels-photo-1146301.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&dpr=1",
      "created_at": "2025-01-19T07:00:21.654Z",
      "updated_at": "2025-01-19T07:00:21.654Z",
      "author_name": "Sandeep Sharma",
      "author_pic": "https://plus.unsplash.com/premium_photo-1689539137236-cbd784b517f5?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "author_designation": "Marine Biologist",
      "blog_views": "50",
      "blog_likes": "30",
      "blog_comments": "5"
    },
    {
      "blog_id": 3,
      "blog_title": "The Art of Mindfulness Meditation",
      "blog_category": "Health",
      "blog_description": "Mindfulness meditation is a practice that has been proven to reduce stress, improve focus, and increase overall well-being. Discover the techniques and benefits of mindfulness in your daily life.",
      "blog_thumbnail": "https://images.pexels.com/photos/1122222/pexels-photo-1122222.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&dpr=1",
      "created_at": "2025-01-19T07:05:12.765Z",
      "updated_at": "2025-01-19T07:05:12.765Z",
      "author_name": "Priya Verma",
      "author_pic": "https://plus.unsplash.com/premium_photo-1689539137236-5a2306a2928e?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "author_designation": "Meditation Instructor",
      "blog_views": "120",
      "blog_likes": "70",
      "blog_comments": "10"
    },
    {
      "blog_id": 4,
      "blog_title": "Sustainable Fashion: Eco-Friendly Choices",
      "blog_category": "Fashion",
      "blog_description": "Sustainable fashion is all about making environmentally friendly choices, from eco-friendly materials to supporting ethical brands. Learn how to build a more sustainable wardrobe.",
      "blog_thumbnail": "https://images.pexels.com/photos/1273647/pexels-photo-1273647.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&dpr=1",
      "created_at": "2025-01-19T07:10:30.876Z",
      "updated_at": "2025-01-19T07:10:30.876Z",
      "author_name": "Neha Kapoor",
      "author_pic": "https://plus.unsplash.com/premium_photo-1689539137236-bf50e6bfae2f?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "author_designation": "Fashion Designer",
      "blog_views": "90",
      "blog_likes": "60",
      "blog_comments": "8"
    },
    {
      "blog_id": 5,
      "blog_title": "The Wonders of Space Exploration",
      "blog_category": "Science",
      "blog_description": "Space exploration continues to capture the imagination of people worldwide. Discover the latest advancements in space technology and missions aimed at unlocking the secrets of our universe.",
      "blog_thumbnail": "https://images.pexels.com/photos/829602/pexels-photo-829602.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&dpr=1",
      "created_at": "2025-01-19T07:15:40.123Z",
      "updated_at": "2025-01-19T07:15:40.123Z",
      "author_name": "Rajesh Kumar",
      "author_pic": "https://plus.unsplash.com/premium_photo-1689539137236-567a2ac46fd4?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "author_designation": "Astronaut",
      "blog_views": "80",
      "blog_likes": "45",
      "blog_comments": "12"
    },
    {
      "blog_id": 6,
      "blog_title": "Culinary Delights from Around the World",
      "blog_category": "Food",
      "blog_description": "Indulge in the flavors of the world’s most delicious cuisines, from Italian pasta to Japanese sushi. Experience the rich history behind each dish and the unique ingredients that make them special.",
      "blog_thumbnail": "https://images.pexels.com/photos/1030846/pexels-photo-1030846.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&dpr=1",
      "created_at": "2025-01-19T07:20:50.234Z",
      "updated_at": "2025-01-19T07:20:50.234Z",
      "author_name": "Simran Singh",
      "author_pic": "https://plus.unsplash.com/premium_photo-1689539137236-9927b7e5c462?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "author_designation": "Chef",
      "blog_views": "100",
      "blog_likes": "55",
      "blog_comments": "15"
    },
    {
      "blog_id": 7,
      "blog_title": "The Future of Renewable Energy",
      "blog_category": "Environment",
      "blog_description": "With climate change at the forefront, renewable energy sources like solar and wind are transforming the way we power our world. Learn about the future of sustainable energy and its impact on global economies.",
      "blog_thumbnail": "https://images.pexels.com/photos/89603/pexels-photo-89603.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&dpr=1",
      "created_at": "2025-01-19T07:25:30.345Z",
      "updated_at": "2025-01-19T07:25:30.345Z",
      "author_name": "Ankit Verma",
      "author_pic": "https://plus.unsplash.com/premium_photo-1689539137236-1184eaf17d0d?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "author_designation": "Renewable Energy Expert",
      "blog_views": "120",
      "blog_likes": "70",
      "blog_comments": "18"
    },
    {
      "blog_id": 8,
      "blog_title": "The Influence of Social Media on Modern Society",
      "blog_category": "Social Media",
      "blog_description": "Explore the powerful impact of social media on today’s world. From trends and influencers to social activism, discover how platforms like Instagram and Twitter are shaping our lives and societies.",
      "blog_thumbnail": "https://images.pexels.com/photos/1239290/pexels-photo-1239290.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&dpr=1",
      "created_at": "2025-01-19T07:30:15.456Z",
      "updated_at": "2025-01-19T07:30:15.456Z",
      "author_name": "Karan Patel",
      "author_pic": "https://plus.unsplash.com/premium_photo-1689539137236-b4fa3a07c123?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "author_designation": "Social Media Analyst",
      "blog_views": "150",
      "blog_likes": "85",
      "blog_comments": "25"
    },
    {
      "blog_id": 9,
      "blog_title": "The Renaissance: A Period of Artistic Revolution",
      "blog_category": "History",
      "blog_description": "The Renaissance was a time of extraordinary artistic achievements, from Leonardo da Vinci’s masterpieces to Michelangelo’s iconic sculptures. Discover how this cultural rebirth influenced art, science, and society.",
      "blog_thumbnail": "https://images.pexels.com/photos/1183063/pexels-photo-1183063.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&dpr=1",
      "created_at": "2025-01-19T07:35:50.567Z",
      "updated_at": "2025-01-19T07:35:50.567Z",
      "author_name": "Meera Joshi",
      "author_pic": "https://plus.unsplash.com/premium_photo-1689539137236-46b6f9259b17?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "author_designation": "Art Historian",
      "blog_views": "200",
      "blog_likes": "120",
      "blog_comments": "30"
    },
    {
      "blog_id": 10,
      "blog_title": "How AI is Changing the Healthcare Industry",
      "blog_category": "Technology",
      "blog_description": "AI technologies are revolutionizing healthcare, improving diagnostic accuracy, personalizing treatments, and transforming patient care. Learn about the latest innovations in AI and their impact on the medical field.",
      "blog_thumbnail": "https://images.pexels.com/photos/6153354/pexels-photo-6153354.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      "created_at": "2025-01-19T07:40:30.678Z",
      "updated_at": "2025-01-19T07:40:30.678Z",
      "author_name": "Ravi Singh",
      "author_pic": "https://plus.unsplash.com/premium_photo-1689539137236-20d71f342619?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "author_designation": "AI Specialist",
      "blog_views": "250",
      "blog_likes": "150",
      "blog_comments": "40"
    }
  ]

  useEffect(() => {
    document.body.style.overflow = 'auto'
  });

  useEffect(() => {

    const fetchBlogs = async () => {
      try {
        const response = await fetch(`${API_URL}/web/blogs/blog-list`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();
        if (result.header.resCode === 200 && result.data.length > 0) {
          const blogData = result.data;
          setBlogs(blogData);
          const mostViewedBlog = blogData.reduce((maxBlog, currentBlog) => {
            return parseInt(currentBlog.blog_views, 10) > parseInt(maxBlog.blog_views, 10)
              ? currentBlog
              : maxBlog;
          }, blogData[0]);
          setFeaturedBlog(mostViewedBlog);
        }
      } catch (error) {
        console.error('Error fetching blog data:', error);
      }
    };

    fetchBlogs();
  }, []);

  useEffect(() => {

    const results = blogs.filter(blog =>
      blog.blog_title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      blog.author_name.toLowerCase().includes(searchQuery.toLowerCase()) // Filtering by name
    );

    if (results.length === 0 && searchQuery) {
      setFilteredBlogs([]);
    } else {
      setFilteredBlogs(results);
    }
  }, [searchQuery, blogs]);

  const onLoadMoreClick = () => {
    setVisible(prevVisible => prevVisible + 6);
  };

  const handleWriteBlogClick = () => {
    navigate("/pg/blogs/write");
  };


  return (
    <AnimationRevealPage>
      <PageHeader pageName="Blogs" titleName="" />
      <Container>
        <br />
        <HeadingRow>
          <Heading>Travel Stories That Inspire Your Next Trip.</Heading>
        </HeadingRow>
        {featuredBlog && (
          <BlogContainer key={featuredBlog.blog_id} featured={true}>
            <ButtonContainer>
              <WriteBlogButton onClick={handleWriteBlogClick} >✍ Write Blog</WriteBlogButton>
            </ButtonContainer>
            <br />
            <Blog className="group" onClick={() => navigate(`/pg/blogs/${featuredBlog.blog_id}/read?blogTitle=${featuredBlog.blog_title}`)}>
              <Image imageSrc={featuredBlog.blog_thumbnail} className="h-70!" />
              <Info>
                <Category>{featuredBlog.blog_category}</Category>
                <CreationDate>{new Date(featuredBlog.created_at).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false }).replace(',', '')}</CreationDate>
                <Title>{featuredBlog.blog_title}</Title>
                {/* {featuredBlog.blog_description && <Description>{(featuredBlog.blog_description).split(/\s+/).slice(0, 20).join(' ') + "..Read more"}</Description>} */}
                <AuthorInfo>
                  <AuthorImage
                    src={
                      featuredBlog.author_pic ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s"
                    }
                  />
                  <AuthorNameAndProfession>
                    <AuthorName>{featuredBlog.author_name}</AuthorName>
                    <AuthorProfile>{featuredBlog.author_designation}</AuthorProfile>
                  </AuthorNameAndProfession>
                </AuthorInfo>
                <Stats>
                  <StatItem><AiFillEye size={20} className="icon-spacing" />{featuredBlog.blog_views}</StatItem>
                  <StatItem><AiFillLike size={20} className="icon-spacing" />{featuredBlog.blog_likes}</StatItem>
                  <StatItem><FaComment size={20} className="icon-spacing" />{featuredBlog.blog_comments}</StatItem>
                </Stats>
              </Info>
            </Blog>
          </BlogContainer>
        )}
        <br /><br />
        <SearchContainer>
          <SearchInput
            type="text"
            placeholder="Search blogs..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <SearchButton>Search</SearchButton>
        </SearchContainer>
        <Blogs>
          {filteredBlogs.slice(0, visible).map((blog, index) => (
            <BlogContainer key={blog.blog_id} featured={blog.featured}>
              <Blog className="group" onClick={() => navigate(`/pg/blogs/${blog.blog_id}/read?blogTitle=${blog.blog_title}`)}>
                <Image imageSrc={blog.blog_thumbnail} />
                <Info>
                  <Category>{blog.blog_category}</Category>
                  <CreationDate>{new Date(featuredBlog.created_at).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false }).replace(',', '')}</CreationDate>
                  <Title>{blog.blog_title}</Title>
                  {/* {blog.blog_description && <Description>{(blog.blog_description).split(/\s+/).slice(0, 20).join(' ')+"..Read more"}</Description>} */}
                  <AuthorInfo>
                    <AuthorImage
                      src={
                        blog.author_pic ||
                        "https://via.placeholder.com/48"
                      }
                    />
                    <AuthorNameAndProfession>
                      <AuthorName>{blog.author_name}</AuthorName>
                      <AuthorProfile>{blog.author_designation}</AuthorProfile>
                    </AuthorNameAndProfession>
                  </AuthorInfo>
                  <Stats>
                    <StatItem><AiFillEye size={20} className="icon-spacing" />{blog.blog_views}</StatItem>
                    <StatItem><AiFillLike size={20} className="icon-spacing" />{blog.blog_likes}</StatItem>
                    <StatItem><FaComment size={20} className="icon-spacing" />{blog.blog_comments}</StatItem>
                  </Stats>
                </Info>
              </Blog>
            </BlogContainer>
          ))}
        </Blogs>

        {visible < blogs.length && (
          <ButtonContainer>
            <LoadMoreButton onClick={onLoadMoreClick}>Load More</LoadMoreButton>
          </ButtonContainer>
        )}
        <br /><br />
      </Container>
      <FooterCard />
    </AnimationRevealPage>
  );
};
